// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"8f27fcbf","977":"c11dadbf"}[chunkId] + ".chunk.js";
};